// Module
var code = "<modal-with-header @close=\"close()\" data-id=\"search-item-modal\"> <div slot=\"header\">{{ headerText }}</div> <panel-users v-if=\"type === 'Users'\" :user=\"data\"></panel-users> <panel-organizations v-if=\"type === 'Organizations'\" :organization=\"data\"></panel-organizations> </modal-with-header> ";
// Exports
export default code;